import { AppProgramStatusEnum } from '@/constant';
import { SUPPORT_FORMAT_DATE_LIST } from '@/utils';
import React, { useCallback } from 'react';

import * as API from 'services';

import dayjs from 'dayjs';

import Button from '../common/button';
import { ProgramActionButtonsProps } from './type';

const ProgramActionButtons: React.FC<ProgramActionButtonsProps> = ({
	status,
	className,
	franchiseId,
	programId,
	callbackSuccess,
	programEndDate,
}) => {
	const onApprove = useCallback(
		async (e: React.MouseEvent<HTMLButtonElement>) => {
			e?.stopPropagation?.();
			try {
				await API.approveWorkerFranchiseProgram(franchiseId, [programId]);
				callbackSuccess?.();
			} catch (error) {
				callbackSuccess?.();
				console.error(error);
			}
		},
		[franchiseId, programId, callbackSuccess]
	);

	const onReject = useCallback(
		async (e: React.MouseEvent<HTMLButtonElement>) => {
			e?.stopPropagation?.();
			try {
				await API.rejectWorkerFranchiseProgram(franchiseId, [programId]);
				callbackSuccess?.();
			} catch (error) {
				console.error(error);
			}
		},
		[franchiseId, programId, callbackSuccess]
	);

	const isExpiredProgram = dayjs(
		programEndDate,
		SUPPORT_FORMAT_DATE_LIST
	).isBefore(dayjs(), 'day');

	if (status === AppProgramStatusEnum.APPROVED || !status || isExpiredProgram) {
		return '-';
	}

	return (
		<div className={`flex justify-center gap-2 ${className || ''}`}>
			<Button className="w-20" type="primary" onClick={onApprove}>
				승인
			</Button>
			{status === AppProgramStatusEnum.REQUESTED && (
				<Button className="w-20" type="primary" onClick={onReject}>
					반려
				</Button>
			)}
		</div>
	);
};

export default ProgramActionButtons;
